import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import useAuth from '../../hooks/useAuth';
import { useUserLoginMutation, useUserOAuthLoginMutation } from '../../redux/slices/authSlice';

// Components
import LoginForm from './LoginForm';
import Meta from '../shared/Meta';

import styles from '../../../stylesheets/public/layouts/Register.module.postcss';

function Login() {
  const { auth, dashboardLink } = useAuth();
  const history = useHistory();

  const [queryError, setQueryError] = useState('');

  const [userLogin, { isError: isLoginError, error: loginError }] = useUserLoginMutation();
  const [userOAuthLogin, { isError: isOAuthError, error: oAuthError }] = useUserOAuthLoginMutation();
  const isError = isLoginError || isOAuthError;
  const error = loginError || oAuthError;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorMsg = params.get('error');
    if (errorMsg) setQueryError(decodeURIComponent(errorMsg));
  }, []);

  useEffect(() => {
    if (auth.loggedIn && auth.initialized) {
      history.push(dashboardLink);
    }
  }, [auth.loggedIn, auth.initialized, dashboardLink, history]);

  return (
    <div className={cn(styles.Login, 'u-blockCenter u-limitWidth35 u-mb3 u-mt3')}>
      <Meta noindex />
      <h1 className='u-mb3 u-textCenter'>Log In</h1>
      <div className='Box Box--white'>
        <div>
          {(isError || queryError) &&
            <div className={styles.FormMessages}>
              <span className='icon icon-warning' />
              <h4>
                { queryError || error?.data?.reason || 'There was an error logging you in. Please try again.' }
              </h4>
            </div>
          }

          <div className='u-mb1'>
            <LoginForm onSubmit={userLogin} />
          </div>
          <hr className={styles.OrRule} />
          <div className='u-mb1'>
            <button
              type='button'
              className={cn('Button Button--outlined u-w100', styles.Button__facebook)}
              onClick={() => {
                userOAuthLogin({
                  provider: 'facebook',
                  params: { needs_user_type: true }
                });
              }}
            >
              <img src='/static/images/icons/facebook-logo-secondary.png' alt='Login with Facebook' />
              <span>Login with Facebook</span>
            </button>

            <button
              type='button'
              className={cn('Button Button--outlined u-w100', styles.Button__google, 'u-ml0 u-mt1')}
              onClick={() => {
                userOAuthLogin({
                  provider: 'google',
                  params: { needs_user_type: true }
                });
              }}
            >
              <img src='/static/images/icons/google.svg' alt='Sign in with Google' />
              <span>Sign in with Google</span>
            </button>

            <button
              type='button'
              className={cn('Button u-w100 u-mt1', styles.Button__apple)}
              onClick={() => {
                userOAuthLogin({
                  provider: 'apple',
                  params: { needs_user_type: true }
                });
              }}
            >
              <img src='/static/images/appleid_button.png' height='48' alt='Sign in with Apple' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
